import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import View from './PensionsOverviewView';
import pensionsSelector, {
  isEmptyStateSelector,
  viewIDSelector,
  graphPensionsSelector,
} from './PensionsOverviewSelector';
import { fetchDataIfNecessary } from '../../AdvWorkflow/AdvWorkflowCacheActions';
import dirtyNodesMapSelector from '../../AdvWorkflow/AdvWorkflowCacheSelector';
import {
  data2 as data2Selector,
  iterator as iteratorSelector,
  currentClientIdOrDefaultSelector,
  stepsToSkipSelector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import { updateData, updateSupportData } from '../../AdvWorkflow/AdvWorkflowActions';
import { BACKEND_KEY, PENSIONS_CRUD_ADD_EDIT } from '../PensionWorkflowConstants';

const mapStateToProps = (state, ownProps) => ({
  shouldSkip: stepsToSkipSelector(state, ownProps).Pensions,
  iterator: iteratorSelector(state, ownProps),
  hasPension: data2Selector(state, ownProps)(`${BACKEND_KEY}.HasPension`),
  alreadyHasPensionData: !!data2Selector(state, ownProps)(`${BACKEND_KEY}.AlreadyHasPensionData`),
  pensions: pensionsSelector(state, ownProps),
  graphPensions: graphPensionsSelector(state, ownProps),
  isEmptyState: isEmptyStateSelector(state, ownProps),
  viewID: viewIDSelector(state, ownProps),
  clientId: currentClientIdOrDefaultSelector(state, ownProps),
  dirtyNodesMap: dirtyNodesMapSelector(state, ownProps),
});
const mapDispatchToProps = dispatch => ({
  fetchData: (workflowId, clientId, dirtyNodesMap) => {
    dispatch(fetchDataIfNecessary(
      workflowId,
      clientId,
      [BACKEND_KEY, 'PensionTypes', 'PensionOwners'],
      dirtyNodesMap,
      false,
    ));
  },
  onRemovePension: (workflowId, clientId, graphPensions, pensionID) => () => {
    dispatch(updateData(
      {
        [BACKEND_KEY]: graphPensions.map((graphPension) => {
          if (graphPension.Id === pensionID) {
            return {
              ...graphPension,
              IsDeleted: true,
            };
          }
          return graphPension;
        }),
      },
      workflowId,
      clientId,
    ));
  },
  onAddPension: (workflowId, clientId, graphPensions) => () => {
    const frontEndId = uuidv4();
    dispatch(updateData(
      {
        [BACKEND_KEY]: graphPensions.concat({
          frontEndId,
        }),
      },
      workflowId,
      clientId,
    ));
    dispatch(updateSupportData(
      {
        [BACKEND_KEY]: {
          PensionStepViewID: PENSIONS_CRUD_ADD_EDIT,
          PensionStepID: frontEndId,
          PensionStepIsEdit: false,
        },
      },
      workflowId,
      clientId,
    ));
  },
  onEditPension: (workflowId, clientId, pensionID) => () => {
    dispatch(updateSupportData(
      {
        [BACKEND_KEY]: {
          PensionStepViewID: PENSIONS_CRUD_ADD_EDIT,
          PensionStepID: pensionID,
          PensionStepIsEdit: true,
        },
      },
      workflowId,
      clientId,
    ));
  },
  onPostSave: (workflowId, clientId) => (data) => {
    dispatch(updateSupportData(
      {
        [BACKEND_KEY]: {
          HasPension: data[BACKEND_KEY] && data[BACKEND_KEY].length !== 0,
        },
      },
      workflowId,
      clientId,
    ));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
